import React from "react"
import { FilledTextFieldProps, TextField } from "@mui/material"
import { useStyles } from "./styles"

export interface TextInputProps
  extends Omit<FilledTextFieldProps, "variant" | "size" | "type"> {
  size?: "small" | "normal"
  type?: "outline" | "solid"
  inline?: boolean
  warning?: boolean
  placeholder?: string
  inputType?: FilledTextFieldProps["type"]
  helperText?: any // Add helperText prop
}

const TextInput = React.forwardRef<HTMLDivElement, TextInputProps>(
  (
    {
      name,
      value,
      placeholder,
      label,
      className,
      size = "normal",
      type = "outline",
      multiline = false,
      required = false,
      inline = false,
      disabled = false,
      error = false,
      warning = false,
      onChange,
      InputProps = {},
      inputProps = {},
      inputRef,
      inputType,
      helperText,
      "aria-label": ariaLabel,
      ...rest
    },
    ref
  ) => {
    const { classes, cx } = useStyles({
      inline,
      label: !!label,
      size,
      type,
      disabled,
      error,
      warning,
      multiline
    })

    return (
      <TextField
        ref={ref}
        className={cx(classes.input, className)}
        name={name}
        value={value}
        onChange={onChange}
        label={label}
        placeholder={placeholder}
        variant="filled"
        multiline={multiline}
        disabled={disabled}
        required={required}
        error={error}
        InputProps={{ disableUnderline: true, ...InputProps }}
        inputProps={{ "aria-label": ariaLabel, ...inputProps }}
        inputRef={inputRef}
        type={inputType}
        helperText={helperText}
        {...rest}
      />
    )
  }
)

export default TextInput
